// Single source of truth for dev/prod in the dashboard bundle. CRA's
// `npm run build` always hardcodes NODE_ENV=production, so REACT_APP_ENV is
// the var that actually reflects which deployment this bundle was built for
// (set as a Docker build arg per compose file — see docker-compose.dev.yml
// / docker-compose.prod.yml).
export const APP_ENV = process.env.REACT_APP_ENV === 'development' ? 'development' : 'production'
export const isDev = APP_ENV === 'development'
